import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  // SearchPanel,
} from "devextreme-react/data-grid";

export default function TimesheetSummaryDataTableList({
  isXSmall,
  isSmall,
  dataGrid,
  onCellPrepared,
  dataTable,
}) {
  return (
    <DataGrid
      height={document.documentElement.offsetHeight - 189}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      rowAlternationEnabled={true}
      columnAutoWidth={true}
      columnHidingEnabled={true}
      alignment="center"
      ref={(e) => {
        dataGrid.current = e;
      }}
      dataSource={dataTable}
      className="datagrid-has-toolbar-actions"
      onCellPrepared={onCellPrepared}
    >
      {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}
      <Selection
        mode="multiple"
        selectAllMode="page"
        showCheckBoxesMode="always"
      />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />
      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />
      <Column
        caption="Employee Code"
        dataField="EmployeeCode"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 1 : false}
        fixed={isXSmall ? false : true}
        fixedPosition="left"
      />
      <Column
        caption="Period"
        dataField="Period.PeriodName"
        hidingPriority={isXSmall || isSmall ? 1 : false}
        fixed={isXSmall ? false : true}
        fixedPosition="left"
      />
      <Column
        caption="Department Name"
        dataField="DepartmentName"
        dataType="string"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Shif tName"
        dataField="ShiftName"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Shift Time In"
        dataField="ShiftTimeIn"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Shift Time Out"
        dataField="ShiftTimeOut"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Time In"
        dataField="TimeIn"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Time Out"
        dataField="TimeOut"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Adjustment Time In"
        dataField="AdjustmentTimeIn"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="AdjTime In Is Next Day"
        dataField="AdjTimeInIsNextDay"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Adjustmen Time Out"
        dataField="AdjustmentTimeOut"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="AdjTime Out Is Next Day"
        dataField="AdjTimeOutIsNextDay"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Reason"
        dataField="Reason"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Explain"
        dataField="Explain"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Approval Status"
        dataField="ApprovalStatus"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Approval Comments"
        dataField="ApprovalComments"
        hidingPriority={isXSmall ? 1 : false}
      />
    </DataGrid>
  );
}
